import { useEffect, useState } from 'react';

/**
 * Fetches /api/drishti/meta once per mount and returns the stamp the footer
 * renders. Falls back to a placeholder if the endpoint is unreachable —
 * we never want a missing stamp to hide the rest of the UI.
 */

export default function useKnowledgeStamp() {
  const [stamp, setStamp] = useState({
    version: null,
    last_reviewed: null,
    loading: true,
    errored: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch('/api/drishti/meta');
        if (!res.ok) throw new Error(`http ${res.status}`);
        const json = await res.json();
        if (!cancelled) {
          setStamp({
            version: json.version,
            last_reviewed: json.last_reviewed,
            loading: false,
            errored: false,
          });
        }
      } catch (_err) {
        if (!cancelled) {
          setStamp((s) => ({ ...s, loading: false, errored: true }));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return stamp;
}
